module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "activeMenu": "rentals"
    }
  }, [_c('v-panel', [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    attrs: {
      "id": "rentals-details"
    }
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_vm._l((_vm.error), function(err) {
    return (_vm.error && typeof(_vm.error) == 'object') ? _c('div', {
      staticClass: "alert alert-danger alert-dismissable"
    }, [_vm._v("\n            " + _vm._s(err[0]) + "\n          ")]) : _vm._e()
  }), _vm._v(" "), (_vm.error && typeof(_vm.error) == 'string') ? _c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [_vm._v("\n            " + _vm._s(_vm.error) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_vm._v("\n            " + _vm._s(_vm.success) + "\n          ")]) : _vm._e(), _vm._v(" "), (_vm.originalRentalData) ? _c('a', {
    staticClass: "back-to-list",
    attrs: {
      "href": "/"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.goBack()
      }
    }
  }, [_c('i', {
    staticClass: "icon md-chevron-left"
  }), _vm._v(_vm._s(_vm.$t('rentals.detail.go_back')))]) : _vm._e(), _vm._v(" "), (!_vm.originalRentalData) ? _c('a', {
    staticClass: "back-to-list",
    attrs: {
      "href": "#/rentals"
    }
  }, [_c('i', {
    staticClass: "icon md-chevron-left"
  }), _vm._v(_vm._s(_vm.$t("rentals.detail.back_to_list")))]) : _vm._e(), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "role": "form",
      "autocomplete": "off",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        !_vm.rental.id ? _vm.save_rental(_vm.rental) : _vm.edit_rental(_vm.rental, 'rental-list')
      }
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-heading"
  }, [_c('h3', {
    staticClass: "panel-title"
  }, [_c('i', {
    staticClass: "icon-rental-home"
  }), _vm._v(" " + _vm._s(!_vm.rental.id ?
    _vm.$t("rentals.detail.title") : _vm.rental.name) + "\n                ")]), _vm._v(" "), _c('div', {
    staticClass: "panel-actions"
  }, [(_vm.activeTab === 'rental-info') ? _c('div', [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic btn-with-caret",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.actions")) + "\n                        "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [(_vm.activeTab === 'rental-info') ? _c('li', [_c('a', [_c('input', {
    staticClass: "button-to-a",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.$t('button.save')
    }
  })])]) : _vm._e(), _vm._v(" "), (!_vm.user.is_team_member && _vm.activeTab === 'rental-info' && _vm.rental.id) ? _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.duplicateRental(_vm.rental)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.duplicate')))])]) : _vm._e(), _vm._v(" "), (!_vm.user.is_team_member && _vm.rental.id && _vm.activeTab == 'rental-info') ? _c('li', [_c('a', {
    attrs: {
      "href": "",
      "data-target": ".example-modal-sm"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.delete_rental(_vm.rental.id)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.delete")))])]) : _vm._e(), _vm._v(" "), (_vm.rental.id) ? _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openImportBookingsModal()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.import_bookings')))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'invoice') ? _c('div', [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic btn-with-caret",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.actions")) + "\n                        "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "",
      "data-target": ".example-modal-sm"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.edit_rental(_vm.rental, 'rental-detail')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.save")))])])])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'templates') ? _c('div', [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic btn-with-caret",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.actions")) + "\n                        "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [(_vm.rental.id) ? _c('li', [_c('a', {
    attrs: {
      "href": "",
      "data-toggle": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.edit_rental(_vm.rental, 'rental-detail')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t("button.save")))])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "",
      "data-target": ".example-modal-sm",
      "data-toggle": "modal"
    }
  }, [_vm._v(_vm._s(_vm.$t("button.save_custom_template")))])])])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'services') ? _c('div', [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic btn-with-caret",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.actions")) + "\n                        "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [(_vm.activeTab == 'services') ? _c('li', [_c('a', {
    attrs: {
      "href": ""
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.updateRentalServices($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save')))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'checklists') ? _c('div', [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic btn-with-caret",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.actions")) + "\n                        "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [(_vm.activeTab == 'checklists') ? _c('li', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        _vm.openCheckListModal()
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('rentals.detail.checklists.create_a_new_checklist')))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'forms') ? _c('div', [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic btn-with-caret",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.actions")) + "\n                        "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [(_vm.activeTab == 'forms') ? _c('li', {
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        _vm.openFormModal()
      }
    }
  }, [_c('a', [_vm._v(_vm._s(_vm.$t('rentals.detail.forms.create_a_new_form')))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'platforms') ? _c('div', [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic btn-with-caret",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.actions")) + "\n                        "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [(_vm.activeTab == 'platforms') ? _c('li', {
    staticClass: "cursor-pointer"
  }, [_c('a', {
    attrs: {
      "data-target": ".example-modal-sm"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.savePlatforms()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save')))])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'parameters') ? _c('div', [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic btn-with-caret",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.actions")) + "\n                        "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [_c('a', [_c('input', {
    staticClass: "button-to-a",
    attrs: {
      "type": "submit"
    },
    domProps: {
      "value": _vm.$t('button.save')
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'vrbo-configuration-tab') ? _c('div', [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic btn-with-caret",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.actions")) + "\n                        "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [_c('a', [_c('input', {
    staticClass: "button-to-a",
    attrs: {
      "type": "button",
      "value": _vm.$t('button.save')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveVrboConfigurationTabData()
      }
    }
  })])])])])]) : _vm._e(), _vm._v(" "), (_vm.activeTab === 'web-site') ? _c('div', [_c('div', {
    staticClass: "dropdown dropdown_btn"
  }, [_c('button', {
    staticClass: "btn btn-warning waves-effect waves-classic btn-with-caret",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.actions")) + "\n                        "), _c('span', {
    staticClass: "dropdown-toggle"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('li', [_c('a', [_c('input', {
    staticClass: "button-to-a",
    attrs: {
      "type": "button",
      "value": _vm.$t('button.save')
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.saveWebsiteData()
      }
    }
  })])])])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "page-tabs"
  }, [_c('ul', {
    staticClass: "nav nav-pills"
  }, [(_vm.activeTab) ? _c('li', {
    class: _vm.activeTab === 'rental-info' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('rental-info')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("rentals.detail.rental_info")) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.rental.id) ? _c('li', {
    class: _vm.activeTab === 'templates' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('templates')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("rentals.detail.contract")) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.rental.id) ? _c('li', {
    class: _vm.activeTab === 'invoice' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('invoice')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("rentals.detail.invoice")) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.rental.id) ? _c('li', {
    class: _vm.activeTab === 'services' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('services')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("rentals.detail.services")) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.rental.id) ? _c('li', {
    class: _vm.activeTab === 'checklists' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('checklists')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("rentals.detail.checklists.title")) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.rental.id) ? _c('li', {
    class: _vm.activeTab === 'forms' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('forms')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("rentals.detail.forms.title")) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.rental.id) ? _c('li', {
    class: _vm.activeTab === 'platforms' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('platforms')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("rentals.detail.platforms.title")) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.rental.id) ? _c('li', {
    class: _vm.activeTab === 'parameters' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('parameters')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("rentals.detail.parameters.title")) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.user.vrbo_enabled && _vm.rental.id && _vm.vrbo.vrbo_account_active) ? _c('li', {
    class: _vm.activeTab === 'vrbo-configuration-tab' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('vrbo-configuration-tab')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.vrbo")) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.rental.id) ? _c('li', {
    class: _vm.activeTab === 'web-site' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('web-site')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("account.settings.website.title")) + "\n                ")]) : _vm._e(), _vm._v(" "), (_vm.rental.id) ? _c('li', {
    class: _vm.activeTab === 'event-logger' ? 'active' : '',
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.change_tab('event-logger')
      }
    }
  }, [_vm._v("\n                  " + _vm._s(_vm.$t("logs.tab")) + "\n                ")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    class: _vm.customTemplate.id ? ' modal fade example-modal-lg margin-top-80' : ' modal fade example-modal-sm margin-top-80',
    attrs: {
      "id": "template-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    class: _vm.customTemplate.id ? ' modal-dialog modal-lg  modal-center' : ' modal-dialog modal-sm  modal-center'
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "display": "block"
    }
  }, [_c('form', {
    staticStyle: {
      "display": "block"
    },
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.customTemplate.id ? _vm.update_custom_template(_vm.rental, _vm.customTemplate) : _vm.save_custom_template(_vm.rental)
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('rentals.detail.template_modal_title')) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#template-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_vm._l((_vm.error), function(err) {
    return (_vm.error && typeof(_vm.error) == 'object') ? _c('div', {
      staticClass: "alert alert-danger alert-dismissable"
    }, [_vm._v("\n                        " + _vm._s(err[0]) + "\n                      ")]) : _vm._e()
  }), _vm._v(" "), (_vm.error && typeof(_vm.error) == 'string') ? _c('div', {
    staticClass: "alert alert-danger alert-dismissable"
  }, [_vm._v("\n                        " + _vm._s(_vm.error) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('div', {
    staticClass: "alert alert-success alert-dismissable"
  }, [_vm._v("\n                        " + _vm._s(_vm.success) + "\n                      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 margin-top-30"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label template_name",
    attrs: {
      "for": "template_name"
    }
  }, [_vm._v(_vm._s(_vm.$t("input.template_name")))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.customTemplate.name),
      expression: "customTemplate.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "template_name",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.customTemplate.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.customTemplate, "name", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.customTemplate.id),
      expression: "customTemplate.id"
    }],
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('div', {
    attrs: {
      "id": "redact"
    }
  })])])])], 2), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "id": "modal-close",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.close_modal()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.cancel")) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.save")) + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade select-date-modal",
    attrs: {
      "id": "checklists-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center modal-md"
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "display": "block"
    }
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.newChecklistGroup.id ? _vm.updateChecklistGroup(_vm.newChecklistGroup, _vm.rental.id) : _vm.saveChecklistGroup(_vm.newChecklistGroup, _vm.rental.id)
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('rentals.detail.checklists.checklist')) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeChecklistModal('#checklists-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body pl-0 pr-0 pb-0"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checklist-title"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("input.title")) + "\n                            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newChecklistGroup.title),
      expression: "newChecklistGroup.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "checklist-title",
      "required": ""
    },
    domProps: {
      "value": (_vm.newChecklistGroup.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newChecklistGroup, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checklist-description"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("input.description")) + "\n                            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newChecklistGroup.description),
      expression: "newChecklistGroup.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "checklist-description",
      "required": ""
    },
    domProps: {
      "value": (_vm.newChecklistGroup.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newChecklistGroup, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checklist-type"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("input.type")) + "\n                          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newChecklistGroup.checklist_group_type_id),
      expression: "newChecklistGroup.checklist_group_type_id"
    }],
    staticClass: "form-control type-select",
    attrs: {
      "id": "checklist-type"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newChecklistGroup, "checklist_group_type_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.checlistGroupTypes), function(checklistGroupType) {
    return _c('option', {
      domProps: {
        "value": checklistGroupType.id
      }
    }, [_vm._v("\n                              " + _vm._s(checklistGroupType.name) + "\n                            ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-11 m-auto"
  }, [_c('ul', {
    staticClass: "checklist-items-container"
  }, [_vm._l((_vm.checklists), function(checklist, index) {
    return _c('li', {
      staticClass: "row edit-checklist-item"
    }, [_c('div', {
      staticClass: "col-md-10 edit-checklist"
    }, [_c('div', {
      staticClass: "list-style"
    }), _vm._v(" "), _c('textarea-autosize', {
      ref: index,
      refInFor: true,
      staticClass: "form-control edit-checklist-name",
      attrs: {
        "name": "checklist-name-index",
        "autofocus": "autofocus",
        "cols": "30",
        "rows": "1"
      },
      model: {
        value: (checklist.name),
        callback: function($$v) {
          _vm.$set(checklist, "name", $$v)
        },
        expression: "checklist.name"
      }
    })], 1), _vm._v(" "), _c('div', {
      staticClass: "col-md-2 d-flex justify-content-between align-items-center"
    }, [_c('div', {
      staticClass: "checklist-arrow-container"
    }, [(index !== 0) ? _c('img', {
      attrs: {
        "src": "/static/assets/images/SuperHote_icons/arrow-up.svg",
        "alt": "NO IMAGE"
      },
      on: {
        "click": function($event) {
          _vm.orderChecklistItem('up', index)
        }
      }
    }) : _vm._e(), _vm._v(" "), (index !== _vm.checklists.length - 1) ? _c('img', {
      attrs: {
        "src": "/static/assets/images/SuperHote_icons/arrow-down.svg",
        "alt": "NO IMAGE"
      },
      on: {
        "click": function($event) {
          _vm.orderChecklistItem('down', index)
        }
      }
    }) : _vm._e()]), _vm._v(" "), _c('i', {
      staticClass: "icon md-close pull-right cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeFromChecklist(index)
        }
      }
    })])])
  }), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "add-new d-inline-block",
    on: {
      "click": function($event) {
        _vm.addNewChecklist(_vm.checlistItem)
      }
    }
  }, [_vm._v("\n                              +\n                            ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material m-0"
  }, [_c('textarea-autosize', {
    staticClass: "form-control checklists-description",
    attrs: {
      "id": "checklists-description",
      "name": "description",
      "placeholder": _vm.$t('rentals.detail.checklists.add_a_step'),
      "min-height": 30,
      "cols": "30",
      "rows": "1"
    },
    model: {
      value: (_vm.checlistItem),
      callback: function($$v) {
        _vm.checlistItem = $$v
      },
      expression: "checlistItem"
    }
  })], 1)])], 2)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 photo-content"
  }, [_c('h3', {
    staticClass: "title text-capitalize"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("rentals.detail.checklists.photos")) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingImage),
      expression: "!loadingImage"
    }],
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "form-group form-material m-0"
  }, [_c('div', {
    staticClass: "images-rentals"
  }, [_c('div', {
    staticClass: "example m-0"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "input-file-now"
    },
    on: {
      "change": _vm.onChecklistImageChange
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingImage),
      expression: "loadingImage"
    }],
    staticClass: "col-3"
  }, [_c('div', {
    staticClass: "loader-wrapper"
  }, [_c('div', {
    staticClass: "md-preloader"
  }, [_c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "version": "1.1",
      "height": "50",
      "width": "50",
      "viewbox": "0 0 50 50"
    }
  }, [_c('circle', {
    attrs: {
      "cx": "25",
      "cy": "25",
      "r": "22",
      "stroke-width": "4"
    }
  })])])])]), _vm._v(" "), _vm._l((_vm.newChecklistGroup.checklistGroupImages), function(checklistGroupImage, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.loadingImage),
        expression: "!loadingImage"
      }],
      staticClass: "col-3"
    }, [_c('div', {
      staticClass: "photo"
    }, [_c('img', {
      staticClass: "checklists-image",
      attrs: {
        "src": checklistGroupImage.name,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "visuel-wrapper resp-checklists-img-box"
    }, [_c('div', {
      staticClass: "checklists-image-masque"
    }, [_c('button', {
      staticClass: "btn btn-block btn-warning waves-effect waves-classic waves-effect waves-classic",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteChecklistImage(checklistGroupImage.id, index)
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.$t("button.delete")) + "\n                                  ")])])])])])
  }), _vm._v(" "), _vm._l((_vm.checklistGroupImages), function(checklistGroupImage, index) {
    return _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.loadingImage),
        expression: "!loadingImage"
      }],
      staticClass: "col-3"
    }, [_c('div', {
      staticClass: "photo"
    }, [_c('img', {
      attrs: {
        "src": checklistGroupImage.path,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "visuel-wrapper resp-checklists-img-box"
    }, [_c('div', {
      staticClass: "checklists-image-masque"
    }, [_c('button', {
      staticClass: "btn btn-block btn-warning waves-effect waves-classic waves-effect waves-classic",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.removeChecklistImage(index)
        }
      }
    }, [_vm._v("\n                                    " + _vm._s(_vm.$t("button.delete")) + "\n                                  ")])])])])])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeChecklistModal('#checklists-modal')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.cancel")) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.save")) + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade select-date-modal",
    attrs: {
      "id": "form-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center",
    class: _vm.formItem && _vm.formItem.type && _vm.formItem.type.name === 'welcome' ? 'modal-header' : ''
  }, [_c('div', {
    staticClass: "modal-content",
    staticStyle: {
      "display": "block"
    }
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        !_vm.formItem.id ? _vm.storeForm(_vm.rental.id) : _vm.editForm(_vm.rental.id)
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [(!_vm.formItem.id) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                              " + _vm._s(_vm.$t("rentals.detail.forms.create_form")) + "\n                            ")]) : _vm._e(), _vm._v(" "), (_vm.formItem.id) ? _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                              " + _vm._s(_vm.$t("rentals.detail.forms.edit_form")) + "\n                            ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeFormsModal('#form-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body pl-0 pr-0 pb-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingInModal),
      expression: "!loadingInModal"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.formItem && _vm.formItem.type && _vm.formItem.type.name === 'welcome' ? 'col-6' : 'col-12'
  }, [_c('div', {
    staticClass: "div-for-form-info"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "form-title"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("input.title")) + "\n                                    "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.title),
      expression: "formItem.title"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "form-title",
      "name": "title",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formItem.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formItem, "title", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "form-description"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("input.description")) + "\n                                    "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.description),
      expression: "formItem.description"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "form-description",
      "name": "description",
      "placeholder": "",
      "required": ""
    },
    domProps: {
      "value": (_vm.formItem.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formItem, "description", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "form-title"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("input.form_type")) + "\n                                    "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.type),
      expression: "formItem.type"
    }],
    staticClass: "form-control custom-height",
    attrs: {
      "required": "",
      "disabled": _vm.editFormModal
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formItem, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.formTypes), function(t) {
    return _c('option', {
      domProps: {
        "value": t
      }
    }, [_vm._v("\n                                      " + _vm._s(_vm.$t("rentals.detail.forms.form_types." + t.name)) + "\n                                    ")])
  }))])]), _vm._v(" "), (_vm.formItem.type.name === 'checkin') ? _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('div', {
    staticClass: "m-b-10"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "form-title"
    }
  }, [_vm._v("\n                                      " + _vm._s(_vm.$t("input.form_steps")) + "\n                                    ")])]), _vm._v(" "), _vm._l((_vm.steps), function(step) {
    return _c('div', {
      staticClass: "checkbox-custom checkbox-inline checkbox-primary"
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.formSteps[step.id]),
        expression: "formSteps[step.id]"
      }],
      attrs: {
        "type": "checkbox",
        "id": ("form-step-" + (step.id))
      },
      domProps: {
        "checked": Array.isArray(_vm.formSteps[step.id]) ? _vm._i(_vm.formSteps[step.id], null) > -1 : (_vm.formSteps[step.id])
      },
      on: {
        "change": function($event) {
          var $$a = _vm.formSteps[step.id],
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (_vm.$set(_vm.formSteps, step.id, $$a.concat([$$v])))
            } else {
              $$i > -1 && (_vm.$set(_vm.formSteps, step.id, $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
            }
          } else {
            _vm.$set(_vm.formSteps, step.id, $$c)
          }
        }
      }
    }), _vm._v(" "), _c('label', {
      attrs: {
        "for": ("form-step-" + (step.id))
      }
    }, [_vm._v(_vm._s(step.name))])])
  })], 2)]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material m-b-0"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v(_vm._s(_vm.$t('rentals.detail.redirect_type')))])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material radios"
  }, [_c('div', {
    staticClass: "radio-custom checkbox-inline checkbox-primary d-inline-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.redirect_type),
      expression: "formItem.redirect_type"
    }],
    attrs: {
      "type": "radio",
      "value": "url",
      "id": "redirect-url",
      "name": "redirect_url"
    },
    domProps: {
      "checked": _vm._q(_vm.formItem.redirect_type, "url")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.formItem, "redirect_type", "url")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "redirect-url"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.redirect_url")))])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom checkbox-inline checkbox-primary d-inline-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.redirect_type),
      expression: "formItem.redirect_type"
    }],
    attrs: {
      "type": "radio",
      "value": "file",
      "id": "redirect-file",
      "name": "redirect_type"
    },
    domProps: {
      "checked": _vm._q(_vm.formItem.redirect_type, "file")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.formItem, "redirect_type", "file")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "redirect-file"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.redirect_file")))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.redirect_type === 'url'),
      expression: "formItem.redirect_type === 'url'"
    }],
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "form-redirect-url"
    }
  }, [_vm._v("\n                                    " + _vm._s(_vm.$t("input.redirection_url")) + "\n                                    "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.redirect_url),
      expression: "formItem.redirect_url"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "form-redirect-url",
      "name": "redirect-url",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formItem.redirect_url)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formItem, "redirect_url", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.redirect_type === 'file'),
      expression: "formItem.redirect_type === 'file'"
    }],
    staticClass: "col-sm-12"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.redirect_file),
      expression: "formItem.redirect_file"
    }],
    staticClass: "m-b-10"
  }, [_c('a', {
    attrs: {
      "href": _vm.uploadedFilepath ? _vm.uploadedFilepath : _vm.formItem.redirect_file,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.uploadedFilepath ? _vm.uploadedFilepath :
    _vm.formItem.redirect_file))])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingFile),
      expression: "!loadingFile"
    }],
    staticClass: "form-group form-material"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formItem.redirect_file),
      expression: "formItem.redirect_file"
    }],
    attrs: {
      "type": "hidden"
    },
    domProps: {
      "value": (_vm.formItem.redirect_file)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formItem, "redirect_file", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "input-file",
    attrs: {
      "type": "file",
      "id": "upload-file",
      "multiple": ""
    },
    on: {
      "change": _vm.onUploadFileChange
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "upload-file"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.upload_file")))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItem.redirect_type === 'file' && _vm.formItem.redirect_file && !_vm.loadingFile),
      expression: "formItem.redirect_type === 'file' && formItem.redirect_file && !loadingFile"
    }],
    staticClass: "form-group form-material ml-15"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/file-check2.svg",
      "alt": "",
      "width": "35px"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingFile),
      expression: "loadingFile"
    }],
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "image-upload-loading"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loadingFile,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22
    }
  })], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 photo-content"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('input.add_a_photo')) + "\n                                ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loadingImage),
      expression: "!loadingImage"
    }],
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "form-group form-material m-0"
  }, [_c('div', {
    staticClass: "images-rentals"
  }, [_c('div', {
    staticClass: "example m-0"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "form-input-file-now",
      "data-allowed-file-extensions": "jpg png jpeg"
    },
    on: {
      "change": _vm.onFormImageChange
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loadingImage),
      expression: "loadingImage"
    }],
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "image-upload-loading"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loadingImage,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formImageUploaded && _vm.formImage.path && _vm.formImage.path != null),
      expression: "formImageUploaded && formImage.path && formImage.path != null"
    }],
    staticClass: "col-4"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('img', {
    attrs: {
      "src": _vm.formImage.path,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "visuel-wrapper resp-form-img-box"
  }, [_c('div', {
    staticClass: "form-image-masque"
  }, [_c('button', {
    staticClass: "btn btn-block btn-warning waves-effect waves-classic waves-effect waves-classic",
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteFormImage(_vm.formItem.id)
      }
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t("button.delete")) + "\n                                          ")])])])])])])])])]), _vm._v(" "), (_vm.formItem && _vm.formItem.type && _vm.formItem.type.name === 'welcome') ? _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "div-for-form-fileds"
  }, [_c('div', {
    attrs: {
      "id": "add-form-fields"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 offset-1"
  }, [_c('div', {
    staticClass: "form-fields"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checklist-description"
    }
  }, [_vm._v("\n                                          " + _vm._s(_vm.$t("input.label")) + "\n                                          "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formsFields.label),
      expression: "formsFields.label"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "form-field-label",
      "name": "title",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.formsFields.label)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.formsFields, "label", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-fields"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "checklist-description"
    }
  }, [_vm._v("\n                                          " + _vm._s(_vm.$t("input.form_field")) + "\n                                          "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formsFields.type),
      expression: "formsFields.type"
    }],
    staticClass: "form-control custom-height",
    attrs: {
      "type": "text",
      "id": "form-field-type",
      "name": "title"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formsFields, "type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.onFormTypeSelectChange()
      }]
    }
  }, _vm._l((_vm.formsFieldsTypes), function(type) {
    return _c('option', {
      attrs: {
        "selected": ""
      },
      domProps: {
        "value": type
      }
    }, [_vm._v("\n                                            " + _vm._s(type.name) + "\n                                          ")])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-5 offset-1"
  }, [_c('div', {
    staticClass: "form-fields"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "form-field-required-or-optional"
    }
  }, [_vm._v("\n                                          " + _vm._s(_vm.$t("input.mandatory")) + "\n                                          "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formsFields.mandatory),
      expression: "formsFields.mandatory"
    }],
    staticClass: "form-control custom-height",
    attrs: {
      "id": "form-field-required-or-optional",
      "name": "title"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formsFields, "mandatory", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1",
      "selected": ""
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t("input.required")) + "\n                                          ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t("input.optional")) + "\n                                          ")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-5"
  }, [_c('div', {
    staticClass: "form-fields"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "form-field-reference"
    }
  }, [_vm._v("\n                                          " + _vm._s(_vm.$t("input.reference")) + "\n                                          "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formsFields.reference),
      expression: "formsFields.reference"
    }],
    staticClass: "form-control custom-height",
    attrs: {
      "id": "form-field-reference",
      "name": "title"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formsFields, "reference", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.formsFieldsReferences), function(reference, index) {
    return _c('option', {
      attrs: {
        "selected": ""
      },
      domProps: {
        "value": reference
      }
    }, [_vm._v("\n                                            " + _vm._s(reference.name) + "\n                                          ")])
  }))])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeIsInput || _vm.typeIsSelect || _vm.typeIsTextarea),
      expression: "typeIsInput || typeIsSelect || typeIsTextarea"
    }],
    staticClass: "col-5 offset-1"
  }, [_c('div', {
    staticClass: "form-fields"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "form-input-type"
    }
  }, [_vm._v("\n                                          " + _vm._s(_vm.$t("input.form_field_type")) + "\n                                          "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeIsInput),
      expression: "typeIsInput"
    }]
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formsFields.element),
      expression: "formsFields.element"
    }],
    staticClass: "form-control custom-height",
    attrs: {
      "type": "text",
      "id": "form-input-type",
      "name": "inputType"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formsFields, "element", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.onFormInputTypeChange()
      }]
    }
  }, _vm._l((_vm.formsFieldsInputTypes), function(inputType) {
    return _c('option', {
      attrs: {
        "selected": ""
      },
      domProps: {
        "value": inputType
      }
    }, [_vm._v("\n                                              " + _vm._s(inputType['name']) + "\n                                            ")])
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeIsSelect),
      expression: "typeIsSelect"
    }]
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formsFields.element),
      expression: "formsFields.element"
    }],
    staticClass: "form-control custom-height",
    attrs: {
      "type": "text",
      "id": "form-select-type",
      "name": "inputType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formsFields, "element", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.formsFieldsInputTypes), function(inputType) {
    return (inputType['id'] == 7) ? _c('option', {
      domProps: {
        "selected": inputType['id'] == 7,
        "value": inputType
      }
    }, [_vm._v("\n                                              " + _vm._s(inputType['name']) + "\n                                            ")]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeIsTextarea),
      expression: "typeIsTextarea"
    }]
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formsFields.element),
      expression: "formsFields.element"
    }],
    staticClass: "form-control custom-height",
    attrs: {
      "type": "text",
      "id": "form-textarea-type",
      "name": "inputType"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.formsFields, "element", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.formsFieldsInputTypes), function(inputType) {
    return (inputType['id'] == 9) ? _c('option', {
      domProps: {
        "selected": inputType['id'] == 7,
        "value": inputType
      }
    }, [_vm._v("\n                                              " + _vm._s(inputType['name']) + "\n                                            ")]) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.typeIsSelect || (_vm.formsFields.element && _vm.formsFields.element.name == 'radio') || (_vm.formsFields.element && _vm.formsFields.element.name == 'checkbox')),
      expression: "typeIsSelect || (formsFields.element && formsFields.element.name == 'radio') || (formsFields.element && formsFields.element.name == 'checkbox')"
    }]
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectOptionName),
      expression: "selectOptionName"
    }],
    staticClass: "form-control mb-25",
    attrs: {
      "type": "text",
      "id": "form-select-options",
      "name": "selectOptions"
    },
    domProps: {
      "value": (_vm.selectOptionName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.selectOptionName = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.addSelectOption(_vm.selectOptionName)
      }
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('button.add_option')) + "\n                                          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-11 m-auto"
  }, [_c('ul', _vm._l((_vm.formsFields.select_options), function(option, index) {
    return _c('li', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-md-10"
    }, [_c('div', {
      staticClass: "list-style d-inline-block"
    }), _vm._v(" "), _c('span', [_vm._v(_vm._s(option.name))])]), _vm._v(" "), _c('div', {
      staticClass: "col-md-2"
    }, [_c('i', {
      staticClass: "icon md-close pull-right cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          option.id ? _vm.deleteOption(index, option.id) : _vm.removeOption(index)
        }
      }
    })])])
  }))])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-11 m-auto"
  }, [_c('ul', [_c('li', {
    on: {
      "click": function($event) {
        _vm.addNewFormItem()
      }
    }
  }, [_c('div', {
    staticClass: "add-new d-inline-block"
  }, [_vm._v("\n                                        +\n                                      ")]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material m-0"
  }, [(!_vm.fieldIsEditing) ? _c('span', {
    staticClass: "form-control form-description cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t('rentals.detail.forms.add_an_item')))]) : _c('span', {
    staticClass: "form-control form-description cursor-pointer"
  }, [_vm._v(_vm._s(_vm.$t('button.save')))])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.formItems.length > 0),
      expression: "formItems.length > 0"
    }],
    staticClass: "col-11 m-auto add-fields-container"
  }, [_c('table', {
    staticClass: "table text-center"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v(_vm._s(_vm.$t('input.label')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.type')))]), _vm._v(" "), _c('th', [_vm._v("\n                                          " + _vm._s(_vm.$t('input.form_field_type')) + "\n                                        ")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.options')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.required')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.reference')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('input.actions')))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.formItems), function(item, i) {
    return _c('tr', [_c('td', {
      staticClass: "break-word"
    }, [_vm._v("\n                                          " + _vm._s(item.label) + "\n                                        ")]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.type.name))]), _vm._v(" "), (!item.id && item.element != null) ? _c('td', [_vm._v("\n                                          " + _vm._s(item.element.name) + "\n                                        ")]) : (item.id && item.element != null) ? _c('td', [_vm._v("\n                                          " + _vm._s(item.element.name) + "\n                                        ")]) : _c('td'), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "options-table-elements"
    }, _vm._l((item.select_options), function(option) {
      return _c('span', [_vm._v(_vm._s(option.name) + ",")])
    }))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.mandatory))]), _vm._v(" "), _c('td', [_vm._v("\n                                          " + _vm._s(item.reference ? item.reference.name :
      '') + "\n                                        ")]), _vm._v(" "), _c('td', [_c('span', {
      staticClass: "cursor-pointer mr-5",
      on: {
        "click": function($event) {
          item.id ? _vm.deleteItemFromForm(item.id, i) : _vm.removeItemFromFormItems(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    })]), _c('span', [_vm._v("|")]), _c('span', {
      staticClass: "cursor-pointer ml-5",
      on: {
        "click": function($event) {
          item.id ? _vm.editItemFromFormItems(i) : _vm.editItemFromFormItems(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit"
    })]), _vm._v(" "), _c('span', {
      staticClass: "cursor-pointer mr-5",
      on: {
        "click": function($event) {
          _vm.orderUp(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-up"
    })]), _c('span', [_vm._v("|")]), _c('span', {
      staticClass: "cursor-pointer ml-5",
      on: {
        "click": function($event) {
          _vm.orderDown(i)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-arrow-down"
    })])])])
  }))])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.loadingInModal
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center form-modal-buttons"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.loadingInModal
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeFormsModal('#form-modal')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.cancel")) + "\n                      ")]), _vm._v(" "), (!_vm.formItem.id) ? _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.loadingInModal
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.create")) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.formItem.id) ? _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit",
      "disabled": _vm.loadingInModal
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.save")) + "\n                      ")]) : _vm._e(), _vm._v(" "), (_vm.form.id) ? _c('router-link', {
    staticClass: "btn btn-block btn-primary waves-effect waves-classic btn-preview",
    attrs: {
      "to": {
        name: 'form.preview',
        params: {
          id: _vm.form.id
        }
      },
      "disabled": _vm.loadingInModal,
      "target": "_blank"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.preview")) + "\n                      ")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'rental-info'),
      expression: "activeTab === 'rental-info'"
    }],
    attrs: {
      "id": "rental-detail"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("rentals.detail.space_section")) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-name"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.name")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.name),
      expression: "rental.name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "rentals-name",
      "name": "name",
      "required": ""
    },
    domProps: {
      "value": (_vm.rental.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "owner-first-name"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.owner_first_name")) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.owner_first_name),
      expression: "rental.owner_first_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "owner-first-name",
      "name": "owner_first_name"
    },
    domProps: {
      "value": (_vm.rental.owner_first_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "owner_first_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "owner-last-name"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.owner_last_name")) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.owner_last_name),
      expression: "rental.owner_last_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "owner-last-name",
      "name": "owner_last_name"
    },
    domProps: {
      "value": (_vm.rental.owner_last_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "owner_last_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "owner-address"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.owner_address")) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.owner_address),
      expression: "rental.owner_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "owner-address",
      "name": "owner_address"
    },
    domProps: {
      "value": (_vm.rental.owner_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "owner_address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "owner-address"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.owner_post_code")) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.owner_post_code),
      expression: "rental.owner_post_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "owner-post-code",
      "name": "owner_post_code"
    },
    domProps: {
      "value": (_vm.rental.owner_post_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "owner_post_code", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "owner-address"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.owner_city")) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.owner_city),
      expression: "rental.owner_city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "owner-city",
      "name": "owner_city"
    },
    domProps: {
      "value": (_vm.rental.owner_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "owner_city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-property-type-group"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.property_type_groups")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.property_type_group),
      expression: "rental.property_type_group"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rentals-property-type-group",
      "name": "property_type_group",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "property_type_group", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.types), function(value, name) {
    return _c('option', {
      domProps: {
        "value": name
      }
    }, [_vm._v("\n                                  " + _vm._s(value.display) + "\n                                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-property-type"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.property_types")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.property_type),
      expression: "rental.property_type"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rentals-property-type",
      "name": "property_type",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "property_type", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.types[_vm.rental.property_type_group]['value']), function(value) {
    return _c('option', {
      domProps: {
        "value": value.id
      }
    }, [_vm._v("\n                                  " + _vm._s(value.display) + "\n                                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-capacity"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.person_capacity")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.capacity),
      expression: "rental.capacity"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rentals-capacity",
      "name": "capacity",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "capacity", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((300), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v("\n                                  " + _vm._s(n) + "\n                                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "default-person-count"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.default_person_count")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.default_persone_count),
      expression: "rental.default_persone_count"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "default-person-count",
      "name": "default_person",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "default_persone_count", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((300), function(n) {
    return _c('option', {
      domProps: {
        "value": n
      }
    }, [_vm._v("\n                                  " + _vm._s(n) + "\n                                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bedroom-count"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('input.bedroom_count')) + "\n                              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.bedroom_count),
      expression: "rental.bedroom_count"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bedroom-count",
      "name": "bedroom_count",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "bedroom_count", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((15), function(n) {
    return _c('option', {
      domProps: {
        "value": n - 1
      }
    }, [_vm._v("\n                                  " + _vm._s(n - 1) + "\n                                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "bathroom-count"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('input.bathroom_count')) + "\n                              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.bathroom_count),
      expression: "rental.bathroom_count"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "bathroom-count",
      "name": "bathroom_count"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "bathroom_count", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((15), function(n) {
    return _c('option', {
      domProps: {
        "value": n - 1
      }
    }, [_vm._v("\n                                  " + _vm._s(n - 1) + "\n                                ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-price"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.daily_price")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.price),
      expression: "rental.price"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "rentals-price",
      "name": "price"
    },
    domProps: {
      "value": (_vm.rental.price)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "price", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.currency))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-pricextra"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.price_for_extra_person")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.price_extra),
      expression: "rental.price_extra"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "rentals-pricextra",
      "name": "price_extra"
    },
    domProps: {
      "value": (_vm.rental.price_extra)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "price_extra", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.currency))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.rental.city_taxes_type == 'per_person' ? 'col-sm-6' : 'col-sm-4'
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "title": _vm.$t('input.cleaning_fees')
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": _vm.$t('input.cleaning_fees'),
      "data-content": _vm.$t('rentals.detail.popovers.cleaning_fees')
    }
  })]), _vm._v("\n                                " + _vm._s(_vm.$t("input.cleaning_fees")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.cleaning),
      expression: "rental.cleaning"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "rentals-cleaning",
      "name": "cleaning"
    },
    domProps: {
      "value": (_vm.rental.cleaning)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "cleaning", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.currency))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rental.city_taxes_type == 'per_person'),
      expression: "rental.city_taxes_type == 'per_person'"
    }],
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "for": "rentals-city-taxes"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.city_taxes")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.city_taxes),
      expression: "rental.city_taxes"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "id": "rentals-city-taxes",
      "name": "city_taxes"
    },
    domProps: {
      "value": (_vm.rental.city_taxes)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "city_taxes", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.currency))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rental.city_taxes_type == 'percent'),
      expression: "rental.city_taxes_type == 'percent'"
    }],
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "for": "city-taxes-percent",
      "title": _vm.$t('rentals.detail.city_taxes.taxes_percent')
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("rentals.detail.city_taxes.taxes_percent")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.taxes_percent),
      expression: "rental.taxes_percent"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "id": "city-taxes-percent"
    },
    domProps: {
      "value": (_vm.rental.taxes_percent)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "taxes_percent", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rental.city_taxes_type == 'percent'),
      expression: "rental.city_taxes_type == 'percent'"
    }],
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "for": "city-taxes-limit",
      "title": _vm.$t('rentals.detail.city_taxes.taxes_limit')
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("rentals.detail.city_taxes.taxes_limit")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.taxes_limit),
      expression: "rental.taxes_limit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "id": "city-taxes-limit"
    },
    domProps: {
      "value": (_vm.rental.taxes_limit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "taxes_limit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.currency))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-deposit"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.deposit")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.deposit),
      expression: "rental.deposit"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "rentals-deposit",
      "name": "deposit"
    },
    domProps: {
      "value": (_vm.rental.deposit)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "deposit", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.currency))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-vat"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.vat")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.vat),
      expression: "rental.vat"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "id": "rentals-vat",
      "name": "vat"
    },
    domProps: {
      "value": (_vm.rental.vat)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "vat", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("%")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 pr-0"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "title": _vm.$t('input.checkin_start_time')
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.checkin_start_time")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.checkin),
      expression: "rental.checkin"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "checkin", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.checkinHours), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                                  " + _vm._s(i) + "\n                                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pr-0"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "title": _vm.$t('input.checkin_end_time')
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.checkin_end_time")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.checkin_end),
      expression: "rental.checkin_end"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "checkin_end", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.checkinHours), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                                  " + _vm._s(i) + "\n                                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pr-0"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "title": _vm.$t('input.checkout_end_time')
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.checkout_end_time")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.checkout),
      expression: "rental.checkout"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "checkout", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.checkinHours), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                                  " + _vm._s(i) + "\n                                ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "title": _vm.$t('input.checkin_duration')
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.checkin_duration")) + "\n                              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.checkin_duration),
      expression: "rental.checkin_duration"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rentals-checkin-duration"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "checkin_duration", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.checkinCheckoutDurationMinutes), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                                  " + _vm._s(i) + "\n                                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pr-0"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "title": _vm.$t('input.checkout_duration')
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.checkout_duration")) + "\n                              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.checkout_duration),
      expression: "rental.checkout_duration"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rentals-checkout-duration"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "checkout_duration", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.checkinCheckoutDurationMinutes), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                                  " + _vm._s(i) + "\n                                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 pr-0"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "title": _vm.$t('input.cut_off_hour')
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.cut_off_hour")) + "\n                              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.cut_off_hour),
      expression: "rental.cut_off_hour"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "cut_off_hour", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t('input.no_limit')) + "\n                                ")]), _vm._v(" "), _vm._l((_vm.cutOffHours), function(i) {
    return _c('option', {
      domProps: {
        "value": i
      }
    }, [_vm._v("\n                                  " + _vm._s(i) + "\n                                ")])
  })], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: _vm.rental.auto_refund ? 'col-sm-6' : 'col-sm-12'
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-status"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.status")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.status),
      expression: "rental.status"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rentals-status",
      "name": "status"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t("input.active")) + "\n                                ")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("\n                                  " + _vm._s(_vm.$t("input.no_active")) + "\n                                ")])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rental.auto_refund),
      expression: "rental.auto_refund"
    }],
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "refund-days"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.refund_days")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.refund_days),
      expression: "rental.refund_days"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "refund-days",
      "name": "refund-days"
    },
    domProps: {
      "value": (_vm.rental.refund_days)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "refund_days", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), (_vm.rental.id) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-8"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "generate-ics-link"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.icsLink")) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.icsLink),
      expression: "rental.icsLink"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "disabled": "",
      "id": "generate-ics-link",
      "name": "ics-link"
    },
    domProps: {
      "value": (_vm.rental.icsLink)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "icsLink", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 d-flex align-items-center"
  }, [_c('div', {
    staticClass: "ical-link",
    attrs: {
      "data-clipboard-text": _vm.rental.icsLink
    },
    model: {
      value: (_vm.rental.icsLink),
      callback: function($$v) {
        _vm.$set(_vm.rental, "icsLink", $$v)
      },
      expression: "rental.icsLink"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-copy"
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.rental.the_keys_locks && _vm.rental.the_keys_locks.length > 0) ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('button', {
    staticClass: "btn btn-primary btn-cons text-uppercase",
    attrs: {
      "data-toggle": "modal",
      "data-target": "#controlLocks-modal",
      "id": "controlLocksButton",
      "type": "button"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('rentals.detail.locks_management')) + "\n                              ")])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("input.address")))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-address"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.address")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.address),
      expression: "rental.address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "rentals-address",
      "name": "address",
      "required": ""
    },
    domProps: {
      "value": (_vm.rental.address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-zip"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.zip_code")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.zip_code),
      expression: "rental.zip_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "rentals-zip",
      "name": "zip_code",
      "required": ""
    },
    domProps: {
      "value": (_vm.rental.zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "zip_code", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-city"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.city")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.city),
      expression: "rental.city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "rentals-city",
      "name": "city",
      "required": ""
    },
    domProps: {
      "value": (_vm.rental.city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-country"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.country")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.country_id),
      expression: "rental.country_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rentals-country",
      "name": "country",
      "required": ""
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "country_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.id
      }
    }, [_vm._v("\n                                  " + _vm._s(country.name) + "\n                                ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-email"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.email")) + "\n                                "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.email),
      expression: "rental.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "rentals-email",
      "name": "email",
      "required": ""
    },
    domProps: {
      "value": (_vm.rental.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "email", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-stripe-account"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('input.select_stripe_account')) + "\n                              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.stripe_account_id),
      expression: "rental.stripe_account_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rentals-stripe-account",
      "name": "rentals-stripe-account"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "stripe_account_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.stripe_accounts), function(stripe_account) {
    return _c('option', {
      domProps: {
        "value": stripe_account.id
      }
    }, [_vm._v("\n                                  " + _vm._s(stripe_account.name) + "\n                                ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.sms_integration),
      expression: "rental.sms_integration"
    }],
    attrs: {
      "type": "checkbox",
      "id": "sms_integration",
      "name": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.rental.sms_integration) ? _vm._i(_vm.rental.sms_integration, null) > -1 : (_vm.rental.sms_integration)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rental.sms_integration,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.rental, "sms_integration", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.rental, "sms_integration", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.rental, "sms_integration", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t("input.sms_integration")))])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-content": _vm.$t('rentals.detail.popovers.sms_integration')
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material d-flex"
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary d-flex payment-option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.payment_integration),
      expression: "rental.payment_integration"
    }],
    attrs: {
      "type": "checkbox",
      "id": "payment-integration",
      "name": "checkbox",
      "disabled": !_vm.rental.stripe_account_id
    },
    domProps: {
      "checked": Array.isArray(_vm.rental.payment_integration) ? _vm._i(_vm.rental.payment_integration, null) > -1 : (_vm.rental.payment_integration)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rental.payment_integration,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.rental, "payment_integration", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.rental, "payment_integration", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.rental, "payment_integration", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t("input.payment_integration")))]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-content": _vm.$t('rentals.detail.popovers.payment_integration')
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material d-flex"
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary d-flex payment-option"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.deposit_integration),
      expression: "rental.deposit_integration"
    }],
    attrs: {
      "type": "checkbox",
      "id": "deposit-integration",
      "name": "checkbox",
      "disabled": !_vm.rental.stripe_account_id
    },
    domProps: {
      "checked": Array.isArray(_vm.rental.deposit_integration) ? _vm._i(_vm.rental.deposit_integration, null) > -1 : (_vm.rental.deposit_integration)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rental.deposit_integration,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.rental, "deposit_integration", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.rental, "deposit_integration", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.rental, "deposit_integration", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t("input.deposit_integration")))]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-content": _vm.$t('rentals.detail.popovers.deposit_integration')
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('div', {
    staticClass: "checkbox-custom checkbox-inline checkbox-primary"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.auto_cancellation),
      expression: "rental.auto_cancellation"
    }],
    attrs: {
      "type": "checkbox",
      "id": "auto-cancellation",
      "disabled": !_vm.rental.stripe_account_id
    },
    domProps: {
      "checked": Array.isArray(_vm.rental.auto_cancellation) ? _vm._i(_vm.rental.auto_cancellation, null) > -1 : (_vm.rental.auto_cancellation)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rental.auto_cancellation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.rental, "auto_cancellation", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.rental, "auto_cancellation", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.rental, "auto_cancellation", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', [_vm._v(_vm._s(_vm.$t('input.auto_cancellation')))])]), _vm._v(" "), _c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "data-content": _vm.$t('rentals.detail.popovers.auto_cancellation')
    }
  })])]), _vm._v(" "), _c('h6', [_vm._v(_vm._s(_vm.$t('rentals.detail.taxes_type.type')))]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material m-t-15 radios"
  }, [_c('div', {
    staticClass: "radio-custom checkbox-inline checkbox-primary d-inline-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.city_taxes_type),
      expression: "rental.city_taxes_type"
    }],
    attrs: {
      "type": "radio",
      "value": "percent",
      "id": "taxes-percent",
      "name": "taxes-type"
    },
    domProps: {
      "checked": _vm._q(_vm.rental.city_taxes_type, "percent")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.rental, "city_taxes_type", "percent")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "taxes-percent"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.taxes_type.percent")))])]), _vm._v(" "), _c('div', {
    staticClass: "radio-custom checkbox-inline checkbox-primary d-inline-block"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.city_taxes_type),
      expression: "rental.city_taxes_type"
    }],
    attrs: {
      "type": "radio",
      "value": "per_person",
      "id": "taxes-people-nights",
      "name": "taxes-type"
    },
    domProps: {
      "checked": _vm._q(_vm.rental.city_taxes_type, "per_person")
    },
    on: {
      "change": function($event) {
        _vm.$set(_vm.rental, "city_taxes_type", "per_person")
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "taxes-people-nights"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.taxes_type.per_person")))])])]), _vm._v(" "), (_vm.rental.id) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rental-property-key"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('rentals.detail.property_key')) + "\n                          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.property_key),
      expression: "rental.property_key"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "rental-property-key",
      "required": "",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.rental.property_key)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "property_key", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('input.currency')) + "\n                            "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.currency_id),
      expression: "rental.currency_id"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rental-currency"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "currency_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.currencies), function(currency) {
    return _c('option', {
      domProps: {
        "value": currency.id
      }
    }, [_vm._v("\n                              " + _vm._s(currency.name) + " " + _vm._s(' (' + currency.symbol +
      ')') + "\n                            ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('account.users.teamMember.assignCheckin')) + "\n                          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.assigned_to_checking),
      expression: "rental.assigned_to_checking"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "assigned_to_checking", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.addOrChangeTeamMember(_vm.rental.id, _vm.rental.assigned_to_checking, 'checking')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-")]), _vm._v(" "), _vm._l((_vm.membersForChecking), function(member) {
    return _c('option', {
      domProps: {
        "value": member.id
      }
    }, [_vm._v("\n                              " + _vm._s(((member.first_name) + " " + (member.last_name))) + "\n                            ")])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('account.users.teamMember.assignCheckout')) + "\n                          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.assigned_to_checkout),
      expression: "rental.assigned_to_checkout"
    }],
    staticClass: "form-control change-booking-status",
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "assigned_to_checkout", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        _vm.addOrChangeTeamMember(_vm.rental.id, _vm.rental.assigned_to_checkout, 'checkout')
      }]
    }
  }, [_c('option', {
    domProps: {
      "value": null
    }
  }, [_vm._v("-")]), _vm._v(" "), _vm._l((_vm.membersForCheckout), function(member) {
    return _c('option', {
      domProps: {
        "value": member.id
      }
    }, [_vm._v("\n                              " + _vm._s(((member.first_name) + " " + (member.last_name))) + "\n                            ")])
  })], 2)])]), _vm._v(" "), _c('div', {
    staticClass: "panel-content-inner",
    staticStyle: {
      "margin-top": "10px"
    }
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v("SuperConcierge")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "title": _vm.$t('input.concierge_percent_commission')
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": _vm.$t('input.concierge_percent_commission'),
      "data-content": _vm.$t('input.concierge_percent_commission_info')
    }
  })]), _vm._v("\n                                " + _vm._s(_vm.$t("input.concierge_percent_commission")) + "\n                              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.concierge_commission),
      expression: "rental.concierge_commission"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "step": "0.01",
      "id": "concierge_percent_commission"
    },
    domProps: {
      "value": (_vm.rental.concierge_commission)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "concierge_commission", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v("%")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "title": _vm.$t('input.concierge_cleaning_fees')
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": _vm.$t('input.concierge_cleaning_fees'),
      "data-content": _vm.$t('input.concierge_cleaning_fees_info')
    }
  })]), _vm._v("\n                                " + _vm._s(_vm.$t("input.concierge_cleaning_fees")) + "\n                              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.concierge_cleaning_fees),
      expression: "rental.concierge_cleaning_fees"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "concierge_cleaning_fees",
      "name": "concierge_cleaning_fees"
    },
    domProps: {
      "value": (_vm.rental.concierge_cleaning_fees)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "concierge_cleaning_fees", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.currency))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "title": _vm.$t('input.concierge_checkin_fees')
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-info-circle fa-specified rental-detail-popover",
    attrs: {
      "data-toggle": "popover",
      "data-trigger": "manual",
      "title": _vm.$t('input.concierge_checkin_fees'),
      "data-content": _vm.$t('input.concierge_checkin_fees_info')
    }
  })]), _vm._v("\n                                " + _vm._s(_vm.$t("input.concierge_checkin_fees")) + "\n                              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.concierge_checkin_fees),
      expression: "rental.concierge_checkin_fees"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "concierge_checkin_fees",
      "name": "concierge_checkin_fees"
    },
    domProps: {
      "value": (_vm.rental.concierge_checkin_fees)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "concierge_checkin_fees", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.currency))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "title": _vm.$t('input.concierge_checkin_fees')
    }
  }, [_vm._v("\n                                Frais de linge\n                              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.concierge_linen_fees),
      expression: "rental.concierge_linen_fees"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "concierge_linen_fees",
      "name": "concierge_linen_fees"
    },
    domProps: {
      "value": (_vm.rental.concierge_linen_fees)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "concierge_linen_fees", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.currency))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label flexible-label",
    attrs: {
      "title": _vm.$t('input.concierge_other_fees')
    }
  }, [_vm._v("\n                                Autres frais\n                              ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.concierge_other_fees),
      expression: "rental.concierge_other_fees"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "concierge_other_fees",
      "name": "concierge_other_fees"
    },
    domProps: {
      "value": (_vm.rental.concierge_other_fees)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "concierge_other_fees", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "input-group-addon"
  }, [_vm._v(_vm._s(_vm.currency))])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 rentals-form-inner",
    attrs: {
      "id": "user-data"
    }
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("input.photo")))]), _vm._v(" "), _c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "input-file-now"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("input.photo")) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "images-rentals"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.rentalImageIsDeleting,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22
    }
  }), _vm._v(" "), ((_vm.rental.photos && _vm.rental.photos.length > 0) && !_vm.rentalImageIsDeleting) ? _c('div', [_c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": (_vm.rental.photos && _vm.rental.photos.length > 0 && _vm.rental.photos[0]) ? _vm.rental.photos[0].name : ''
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "visuel-wrapper"
  }, [_c('div', {
    staticClass: "rental-invoice-masque"
  }, [_c('button', {
    staticClass: "btn btn-block btn-warning waves-effect waves-classic waves-effect waves-classic",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteRentalLogo()
      }
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t("button.delete")) + "\n                                      ")])])])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "id": "input-file-now",
      "data-plugin": "dropify",
      "data-default-file": "",
      "data-allowed-file-extensions": "jpg png jpeg"
    },
    on: {
      "change": _vm.onFileChange
    }
  })])])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'templates'),
      expression: "activeTab === 'templates'"
    }]
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-9 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('redactor', {
    attrs: {
      "contract": _vm.contract,
      "rentalId": _vm.rental.id,
      "shortCodes": _vm.shortCodes
    },
    model: {
      value: (_vm.rental.contract),
      callback: function($$v) {
        _vm.$set(_vm.rental, "contract", $$v)
      },
      expression: "rental.contract"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-3 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("input.template")))]), _vm._v(" "), _vm._l((_vm.templates), function(template) {
    return _c('div', {
      staticClass: "text-align-center margin-top-50"
    }, [_c('div', [_vm._v(_vm._s(template.name))]), _vm._v(" "), _c('div', {
      staticClass: "image-section"
    }, [_c('img', {
      staticClass: "template-frame",
      attrs: {
        "src": template.thumbnail ? template.thumbnail : '/static/assets/images/contract/template-contract.png'
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "use-edit-section"
    }, [_c('div', {
      staticClass: "use-this-button",
      attrs: {
        "data-target": ".example-modal-lg",
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          _vm.changeContract(template)
        }
      }
    }, [_c('div', {
      staticClass: "button-style"
    }, [_vm._v("\n                                  " + _vm._s(_vm.$t('button.use')) + "\n                                ")])]), _vm._v(" "), (template.user_id) ? _c('div', {
      staticClass: "edit-button",
      attrs: {
        "data-target": ".example-modal-lg",
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.edit_template(template)
        }
      }
    }, [_c('div', {
      staticClass: "button-style"
    }, [_vm._v("\n                                  " + _vm._s(_vm.$t('button.edit')) + "\n                                ")])]) : _vm._e()]), _vm._v(" "), (template.user_id) ? _c('i', {
      staticClass: "icon md-close-circle-o remove-button",
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.delete_template(template.id)
        }
      }
    }) : _vm._e()])])
  })], 2)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'invoice'),
      expression: "activeTab === 'invoice'"
    }]
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("rentals.detail.business_details")) + "\n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "invoice-name"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.name")) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.invoice_name),
      expression: "rental.invoice_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "invoice-name",
      "name": "name"
    },
    domProps: {
      "value": (_vm.rental.invoice_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "invoice_name", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "invoice-address"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.address")) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.invoice_address),
      expression: "rental.invoice_address"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "invoice-address",
      "name": "address"
    },
    domProps: {
      "value": (_vm.rental.invoice_address)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "invoice_address", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "invoice-zip-code"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.zip_code")) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.invoice_zip_code),
      expression: "rental.invoice_zip_code"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "invoice-zip-code",
      "name": "zip_code"
    },
    domProps: {
      "value": (_vm.rental.invoice_zip_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "invoice_zip_code", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "invoice-city"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.city")) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.invoice_city),
      expression: "rental.invoice_city"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "invoice-city",
      "name": "city"
    },
    domProps: {
      "value": (_vm.rental.invoice_city)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "invoice_city", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "invoice-country"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.country")) + "\n                              ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.invoice_country),
      expression: "rental.invoice_country"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "invoice-country",
      "name": "country"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "invoice_country", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.countries), function(country) {
    return _c('option', {
      domProps: {
        "value": country.id
      }
    }, [_vm._v("\n                                  " + _vm._s(country.name) + "\n                                ")])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "invoice-business-number"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.business_number")) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.invoice_business_number),
      expression: "rental.invoice_business_number"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "invoice-business-number",
      "name": "business_number"
    },
    domProps: {
      "value": (_vm.rental.invoice_business_number)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "invoice_business_number", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "invoice-footer"
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t("input.footer")) + "\n                              ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.invoice_footer),
      expression: "rental.invoice_footer"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "invoice-footer"
    },
    domProps: {
      "value": (_vm.rental.invoice_footer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "invoice_footer", $event.target.value)
      }
    }
  })])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 rentals-form-inner",
    attrs: {
      "id": "rental-invoice-logo"
    }
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "inner-title"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t("rentals.detail.logo")))]), _vm._v(" "), _c('span', [_vm._v("(333 x 222)")])]), _vm._v(" "), _c('div', {
    staticClass: "images-rentals"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "photo"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.invoiceLogoIsDeleting),
      expression: "invoiceLogoIsDeleting"
    }]
  }, [_c('div', {
    staticClass: "image-upload-loading"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": true,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22
    }
  })], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.rental.invoice_logo && !_vm.invoiceLogoIsDeleting),
      expression: "rental.invoice_logo && !invoiceLogoIsDeleting"
    }]
  }, [(_vm.rental.invoice_logo) ? _c('img', {
    staticClass: "img-responsive",
    attrs: {
      "src": _vm.rental.invoice_logo ? _vm.api_url + '/images/invoice-logo/' + _vm.rental.invoice_logo : ''
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "visuel-wrapper"
  }, [_c('div', {
    staticClass: "rental-invoice-masque"
  }, [_c('button', {
    staticClass: "btn btn-block btn-warning waves-effect waves-classic waves-effect waves-classic",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deleteInvoiceLogo()
      }
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t("button.delete")) + "\n                                      ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "example"
  }, [_c('input', {
    attrs: {
      "type": "file",
      "data-plugin": "dropify",
      "data-default-file": "",
      "data-allowed-file-extensions": "jpg png jpeg",
      "id": "invoice-logo-container"
    },
    on: {
      "change": _vm.onLogoChange
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-4 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v("\n                          " + _vm._s(_vm.$t("rentals.detail.template")) + "\n                        ")]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.templates[0]),
      expression: "templates[0]"
    }],
    staticClass: "text-align-center margin-top-50",
    on: {
      "click": function($event) {
        _vm.changeContract(_vm.templates[0])
      }
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t("rentals.detail.invoice_template")))]), _vm._v(" "), _c('img', {
    staticClass: "template-frame invoice-template-frame",
    attrs: {
      "src": "/static/assets/images/invoice/template-invoice.png"
    }
  })])])])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'channels'),
      expression: "activeTab === 'channels'"
    }]
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('ul', {
    attrs: {
      "id": "channels-list-add"
    }
  }, [_c('li', {
    staticClass: "list-heading"
  }, [_c('div', {
    staticClass: "channel-name"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("rentals.detail.channel_name")) + "\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "channel-active"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("rentals.detail.active")) + "\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "channel-sync"
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("rentals.detail.last_sync")) + "\n                      ")]), _vm._v(" "), _c('div', {
    staticClass: "channel-change"
  })]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "channel-name"
  }, [(_vm.channels && _vm.channels[0] && _vm.channels[0].logo) ? _c('img', {
    attrs: {
      "src": '/static/assets/images/' + _vm.channels[0].logo,
      "height": "32",
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "channel-active"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.channels),
      expression: "rental.channels"
    }],
    attrs: {
      "type": "checkbox",
      "data-plugin": "labelauty",
      "data-labelauty": "OFF|ON"
    },
    domProps: {
      "value": _vm.channels[0],
      "checked": Array.isArray(_vm.rental.channels) ? _vm._i(_vm.rental.channels, _vm.channels[0]) > -1 : (_vm.rental.channels)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rental.channels,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.channels[0],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.rental, "channels", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.rental, "channels", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.rental, "channels", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "channel-sync"
  }, [_vm._v("25 Feb 2017 08:14 PM")]), _vm._v(" "), _c('div', {
    staticClass: "channel-change"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "bulle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('a', {
    staticClass: "dropdown-item waves-effect waves-light waves-round",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.deactivate")))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item waves-effect waves-light waves-round",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.delete")))])])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "channel-name"
  }, [(_vm.channels && _vm.channels[1] && _vm.channels[1].logo) ? _c('img', {
    attrs: {
      "src": '/static/assets/images/' + _vm.channels[1].logo,
      "height": "32",
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "channel-active"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.channels),
      expression: "rental.channels"
    }],
    attrs: {
      "type": "checkbox",
      "data-plugin": "labelauty",
      "data-labelauty": "OFF|ON"
    },
    domProps: {
      "value": _vm.channels[1],
      "checked": Array.isArray(_vm.rental.channels) ? _vm._i(_vm.rental.channels, _vm.channels[1]) > -1 : (_vm.rental.channels)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rental.channels,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.channels[1],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.rental, "channels", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.rental, "channels", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.rental, "channels", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "channel-sync"
  }, [_vm._v("25 Feb 2017 08:14 PM")]), _vm._v(" "), _c('div', {
    staticClass: "channel-change"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "bulle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('a', {
    staticClass: "dropdown-item waves-effect waves-light waves-round",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.deactivate")))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item waves-effect waves-light waves-round",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.delete")))])])])])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "channel-name"
  }, [(_vm.channels && _vm.channels[2] && _vm.channels[2].logo) ? _c('img', {
    attrs: {
      "src": '/static/assets/images/' + _vm.channels[2].logo,
      "height": "32",
      "alt": ""
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "channel-active"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.channels),
      expression: "rental.channels"
    }],
    attrs: {
      "type": "checkbox",
      "data-plugin": "labelauty",
      "data-labelauty": "OFF|ON"
    },
    domProps: {
      "value": _vm.channels[2],
      "checked": Array.isArray(_vm.rental.channels) ? _vm._i(_vm.rental.channels, _vm.channels[2]) > -1 : (_vm.rental.channels)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.rental.channels,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = _vm.channels[2],
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.$set(_vm.rental, "channels", $$a.concat([$$v])))
          } else {
            $$i > -1 && (_vm.$set(_vm.rental, "channels", $$a.slice(0, $$i).concat($$a.slice($$i + 1))))
          }
        } else {
          _vm.$set(_vm.rental, "channels", $$c)
        }
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "channel-sync"
  }, [_vm._v("25 Feb 2017 08:14 PM")]), _vm._v(" "), _c('div', {
    staticClass: "channel-change"
  }, [_c('div', {
    staticClass: "btn-group"
  }, [_c('div', {
    staticClass: "dropdown"
  }, [_c('button', {
    staticClass: "btn btn-primary dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "bulle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu dropdown-menu-right"
  }, [_c('a', {
    staticClass: "dropdown-item waves-effect waves-light waves-round",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.deactivate")))]), _vm._v(" "), _c('a', {
    staticClass: "dropdown-item waves-effect waves-light waves-round",
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.delete")))])])])])])])])])])]), _vm._v(" "), _c('v-services', {
    attrs: {
      "theKeys": _vm.theKeys,
      "activeTab": _vm.activeTab,
      "isSuperCheckinSelected": _vm.isSuperCheckinSelected,
      "isTheKeysSelected": _vm.isTheKeysSelected,
      "isIgloohomeSelected": _vm.isIgloohomeSelected,
      "igloohomeLocks": _vm.igloohomeLocks,
      "igloohomeV2Locks": _vm.igloohomeV2Locks,
      "nukiLocks": _vm.nukiLocks,
      "isNukiLockSelected": _vm.isNukiLockSelected,
      "isIgloohomeV2Selected": _vm.isIgloohomeV2Selected,
      "setNotatmoOrKey": _vm.setNotatmoOrKey,
      "netatmoDevices": _vm.netatmoDevices,
      "rental": _vm.rental,
      "selectNetatmoDeviceId": _vm.selectNetatmoDeviceId,
      "netatmoModules": _vm.netatmoModules,
      "lock_type": _vm.rental.lock_type,
      "accountLockTypes": _vm.accountLockTypes,
      "superCheckinAccount": _vm.superCheckinAccount,
      "superCheckinLocks": _vm.superCheckinLocks,
      "lock_types": _vm.lock_types,
      "onLockDetailsChange": _vm.onLockDetailsChange,
      "updateAllLocks": _vm.updateAllLocks,
      "getLocksOfAccount": _vm.getLocksOfAccount,
      "onLockConnect": _vm.onLockConnect,
      "onChangeLockType": _vm.onChangeLockType,
      "stopWriting": _vm.stopWriting,
      "priceLabEnabled": _vm.serviceData.price_lab_enabled,
      "priceLabEmail": _vm.serviceData.price_lab_email,
      "priceLabApiKey": _vm.serviceData.price_lab_api_key
    },
    on: {
      "enablePriceLab": _vm.enablePriceLab,
      "changePriceLabEmail": _vm.changePriceLabEmail,
      "changePriceLabApiKey": _vm.changePriceLabApiKey
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'checklists'),
      expression: "activeTab === 'checklists'"
    }]
  }, [(_vm.checklistGroups.length == 0) ? _c('div', [_c('div', {
    staticClass: "list-rental-empty"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "no-result"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.checklists.no_checklists_for_this_rental")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openCheckListModal()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("button.setup")) + "\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.checklistGroups.length > 0),
      expression: "checklistGroups.length > 0"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row adding-checklist"
  }, [_c('div', {
    staticClass: "col-xl-4 col-lg-5 p-0 m-0"
  }, [_c('div', {
    staticClass: "content add-new"
  }, [_c('div', {
    staticClass: "add",
    on: {
      "click": function($event) {
        _vm.openCheckListModal()
      }
    }
  }, [_vm._v("+")])])]), _vm._v(" "), _vm._l((_vm.checklistGroups), function(checklistGroup) {
    return _c('div', {
      staticClass: "col-xl-4 col-lg-5 p-0 m-0"
    }, [_c('div', {
      class: _vm.selectedChecklistId == checklistGroup.id ? 'content checklist-item test' : 'content checklist-item'
    }, [_c('div', {
      staticClass: "row m-0 h-100"
    }, [_c('div', {
      staticClass: "col-3 p-0 h-100"
    }, [_c('div', {
      staticClass: "icon h-100"
    }, [(_vm.selectedChecklistId != checklistGroup.id) ? _c('img', {
      attrs: {
        "src": "/static/assets/images/icons2/gray.png",
        "alt": ""
      }
    }) : _vm._e(), _vm._v(" "), (_vm.selectedChecklistId == checklistGroup.id) ? _c('img', {
      staticClass: "icon-valid-list",
      attrs: {
        "src": "/static/assets/images/SuperHote_icons/icon__valid-list.svg",
        "alt": ""
      }
    }) : _vm._e()])]), _vm._v(" "), _c('div', {
      staticClass: "col-7 pl-0"
    }, [_c('div', {
      staticClass: "subject h-100"
    }, [_c('div', {
      staticClass: "descr title"
    }, [_vm._v("\n                                  " + _vm._s(checklistGroup.title) + "\n                                ")]), _vm._v(" "), _c('div', {
      staticClass: "descr properties"
    }, [_vm._v("\n                                  " + _vm._s(checklistGroup.checklists.length) + " " + _vm._s(_vm.$t("rentals.detail.checklists.tasks")) + " | " + _vm._s(checklistGroup.images.length) + " " + _vm._s(_vm.$t("rentals.detail.checklists.photos")) + "\n                                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-2 pt-5"
    }, [_c('div', {
      staticClass: "btn-group rental-checklists"
    }, [_c('div', {
      staticClass: "dropdown"
    }, [_c('button', {
      staticClass: "btn dropdown-toggle",
      attrs: {
        "type": "button",
        "data-toggle": "dropdown"
      }
    }, [_c('i', {
      staticClass: "bulle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right"
    }, [_c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openEditChecklistGroupModal(checklistGroup)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("button.edit")))]), _vm._v(" "), _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.openDuplicateChecklistGroupModal(checklistGroup)
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("button.duplicate")))]), _vm._v(" "), _c('a', {
      staticClass: "dropdown-item waves-effect waves-light waves-round",
      attrs: {
        "href": "#"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.deleteFormOrChecklist(checklistGroup, 'checklist')
        }
      }
    }, [_vm._v(_vm._s(_vm.$t("button.delete")))])])])])])])])])
  })], 2)])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'forms'),
      expression: "activeTab === 'forms'"
    }]
  }, [(_vm.forms.length == 0) ? _c('div', [_c('div', {
    staticClass: "list-rental-empty"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "no-result"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.forms.no_forms_for_this_rental")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openFormModal()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t("button.setup")) + "\n                    ")])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.forms.length > 0),
      expression: "forms.length > 0"
    }],
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('div', {
    staticClass: "row adding-form"
  }, _vm._l((_vm.forms), function(form) {
    return _c('div', {
      staticClass: "col-xl-4 col-lg-5 p-0 m-0"
    }, [_c('div', {
      staticClass: "content form-item"
    }, [_c('div', {
      staticClass: "row m-0 h-100"
    }, [_c('div', {
      staticClass: "col-2 p-0 h-100"
    }, [_c('div', {
      staticClass: "icon h-100"
    }, [_c('img', {
      attrs: {
        "src": "/static/assets/images/icons2/gray.png",
        "alt": ""
      }
    })])]), _vm._v(" "), _c('div', {
      staticClass: "col-9"
    }, [_c('div', {
      staticClass: "subject h-100"
    }, [_c('div', {
      staticClass: "descr title"
    }, [_vm._v(_vm._s(form.title))]), _vm._v(" "), _c('div', {
      staticClass: "descr edit",
      on: {
        "click": function($event) {
          _vm.openEditFormModal(form)
        }
      }
    }, [_vm._v("\n                                  " + _vm._s(_vm.$t("rentals.detail.forms.edit_form")) + "\n                                ")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-1"
    }, [_c('button', {
      staticClass: "close m-t-10",
      attrs: {
        "type": "button",
        "aria-label": "Close"
      },
      on: {
        "click": function($event) {
          _vm.deleteFormOrChecklist(form, 'form')
        }
      }
    }, [_c('span', {
      staticClass: "close-btn",
      attrs: {
        "aria-hidden": "true"
      }
    }, [_vm._v("×")])])])])])])
  }))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'platforms'),
      expression: "activeTab === 'platforms'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "row platforms"
  }, [_c('div', {
    staticClass: "col-xl-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-lg-4",
    attrs: {
      "id": "map-airbnb-rental-tab"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.airbnbAccounts.length == 0 && !_vm.airbnbListingsLoading) ? _c('div', {
    staticClass: "col-12 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "list-rental-empty list-rental-empty-step m-t-5"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "no-result"
  }, [_vm._v(_vm._s(_vm.$t("rentals.detail.platforms.airbnb_not_configured")))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setAirbnb()
      }
    }
  }, [_vm._v("\n                                          " + _vm._s(_vm.$t("button.setup")) + "\n                                        ")])])])])]) : _vm._e(), _vm._v(" "), (_vm.airbnbAccounts.length > 0 && !_vm.airbnbListingsLoading) ? _c('div', {
    staticClass: "col-sm-12 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v("\n                                      " + _vm._s(_vm.$t("rentals.detail.platforms.airbnb")) + "\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [(!_vm.rental.sync_in_progress) ? _c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rentals-airbnb"
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t("input.rental")) + "\n                                          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.airbnbKeyId),
      expression: "airbnbKeyId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "rentals-airbnb"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.airbnbKeyId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": _vm.rental.airbnb_account_id
    },
    domProps: {
      "value": null
    }
  }), _vm._v(" "), _vm._l((_vm.airbnbRentals), function(airbnbRental) {
    return (!_vm.airbnbAttachedRentalIds.includes(parseInt(airbnbRental.id))) ? _c('option', {
      attrs: {
        "disabled": _vm.rental.airbnb_account_id
      },
      domProps: {
        "value": airbnbRental.airbnb_account_id + '-' + airbnbRental.id
      }
    }, [_vm._v("\n                                              " + _vm._s(airbnbRental.name) + " - " + _vm._s(airbnbRental.airbnb_user_email) + "\n                                            ")]) : _vm._e()
  })], 2), _vm._v(" "), (_vm.rental.airbnb_account_id && _vm.rental.airbnb_rental_id && _vm.rental.new_rental === false) ? _c('div', {
    staticStyle: {
      "text-align": "center",
      "margin": "15px auto"
    }
  }, [_c('button', {
    staticClass: "btn btn-setup",
    staticStyle: {
      "display": "inline",
      "max-width": "100%"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.desyncAirbnb
    }
  }, [_vm._v("\n                                              " + _vm._s(_vm.$t('button.desync_airbnb')) + "\n                                            ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.rental.sync_in_progress) ? _c('div', [_c('p', [_vm._v("\n                                            " + _vm._s(_vm.$t('home.sync_data_of_platform')) + "\n                                          ")])]) : _vm._e(), _vm._v(" "), (_vm.rental.airbnbConnectedDate) ? _c('div', [_vm._v("\n                                          " + _vm._s(_vm.$t("rentals.detail.platforms.airbnb_connected")) + "\n                                          " + _vm._s(_vm.rental.airbnbConnectedDate) + "\n                                        ")]) : _vm._e()]), _vm._v(" "), (_vm.rental.airbnbAccount && _vm.rental.airbnbAccount.refresh_token != null) ? _c('div', {
    staticClass: "col-sm-12",
    attrs: {
      "id": "update-data"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v("\n                                                    Modification des informations\n                                                  ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-6 form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("rentals.detail.platforms.availability_range")) + "\n                                                          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.airbnb_availability_range),
      expression: "rental.airbnb_availability_range"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "airbnb_availability_range", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.availability_ranges), function(i) {
    return _c('option', {
      domProps: {
        "value": i.value
      }
    }, [_vm._v("\n                                                              " + _vm._s(i.text) + "\n                                                            ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-6 form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("rentals.detail.platforms.preparation_time")) + "\n                                                          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.airbnb_preparation_time),
      expression: "rental.airbnb_preparation_time"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "airbnb_preparation_time", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.airbnb_preparation_times), function(i) {
    return _c('option', {
      domProps: {
        "value": i.value
      }
    }, [_vm._v("\n                                                              " + _vm._s(i.text) + "\n                                                            ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-6 form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("rentals.detail.platforms.min_nights")) + "\n                                                          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.airbnb_min_nights),
      expression: "rental.airbnb_min_nights"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "rentals-price",
      "name": "airbnb_min_night"
    },
    domProps: {
      "value": (_vm.rental.airbnb_min_nights)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "airbnb_min_nights", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("rentals.detail.platforms.max_nights")) + "\n                                                          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.airbnb_max_nights),
      expression: "rental.airbnb_max_nights"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "rentals-price",
      "name": "airbnb_max_night"
    },
    domProps: {
      "value": (_vm.rental.airbnb_max_nights)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "airbnb_max_nights", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-6 form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                                                            " + _vm._s(_vm.$t("rentals.detail.platforms.reservation_type")) + "\n                                                          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.instant_booking_allowed_category),
      expression: "rental.instant_booking_allowed_category"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "instant_booking_allowed_category", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.instant_booking_allowed_categories), function(i) {
    return _c('option', {
      domProps: {
        "value": i.value
      }
    }, [_vm._v("\n                                                              " + _vm._s(i.text) + "\n                                                            ")])
  }))]), _vm._v(" "), _c('div', {
    staticClass: "col-6 form-group form-material"
  }, [_c('label', {
    staticClass: "control-label"
  }, [_vm._v("\n                                                            Devise\n                                                          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.airbnb_currency),
      expression: "rental.airbnb_currency"
    }],
    staticClass: "form-control",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "airbnb_currency", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.airbnb_currencies), function(i) {
    return _c('option', {
      domProps: {
        "value": i.id
      }
    }, [_vm._v("\n                                                              " + _vm._s(i.label) + " (" + _vm._s(i.id) + ")\n                                                            ")])
  }))])])])])])])])])])]) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.airbnbListingsLoading) ? _c('div', {
    staticClass: "col-sm-12 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.airbnbListingsLoading,
      "isHeightAuto": true
    }
  })], 1)])])])]) : _vm._e()])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-lg-4",
    attrs: {
      "id": "map-rental-email"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "list-rental-empty list-rental-empty-step booking-com-setup-box m-t-5"
  }, [(_vm.rental.booking_hotel_id && _vm.rental.booking_room_id && _vm.rental.booking_rate_id) ? _c('p', {
    staticClass: "activated"
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t('rentals.detail.platforms.activated')) + "\n                                      ")]) : _vm._e(), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "no-result"
  }, [_vm._v(_vm._s(_vm.$t('rentals.detail.platforms.configure_rental_email')))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t('rentals.detail.platforms.configure_rental_email_details')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openRentalEmailModal()
      }
    }
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t('button.setup')) + "\n                                      ")]), _vm._v(" "), (_vm.rental.bookingConnectedDate) ? _c('div', {
    staticClass: "mt-25"
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t("rentals.detail.platforms.booking_com_connected")) + "\n                                        " + _vm._s(_vm.rental.bookingConnectedDate) + "\n                                      ")]) : _vm._e()])])])])])])]), _vm._v(" "), (_vm.user.vrbo_enabled && _vm.vrbo.vrbo_account_active) ? _c('div', {
    staticClass: "col-lg-4",
    attrs: {
      "id": "map-vrbo-rental-tab"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "list-rental-empty list-rental-empty-step booking-com-setup-box m-t-5"
  }, [(_vm.rental.vrbo_rental && _vm.rental.vrbo_rental.active) ? _c('p', {
    staticClass: "activated"
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t('rentals.detail.platforms.activated')) + "\n                                      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "d-flex justify-content-around"
  }, [_c('div', {
    staticClass: "d-flex flex-column"
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "no-result"
  }, [_vm._v(_vm._s(_vm.$t('rentals.detail.platforms.vrbo.configure_vrbo')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.openVrboConfigurationModal()
      }
    }
  }, [_vm._v("\n                                            " + _vm._s(_vm.$t('button.setup')) + "\n                                          ")])])]), _vm._v(" "), (_vm.rental.vrbo_rental && _vm.rental.vrbo_rental.active) ? _c('div', {
    staticClass: "mt-25"
  }, [_vm._v("\n                                        " + _vm._s(_vm.$t("rentals.detail.platforms.vrbo.connected")) + "\n                                        " + _vm._s(_vm.rental.vrbo_rental.last_activated_date) + "\n                                      ")]) : _vm._e()])])])])])])]) : _vm._e(), _vm._v(" "), (_vm.hasAccessToPlanIdFour(_vm.rental.userPlanId ? _vm.rental.userPlanId : null)) ? _c('div', {
    staticClass: "col-lg-4",
    attrs: {
      "id": "price-multiplier"
    }
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h4', {
    staticClass: "inner-title"
  }, [_vm._v("\n                                      " + _vm._s(_vm.$t("rentals.detail.platforms.price_multiplier")) + "\n                                    ")]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "row"
  }, _vm._l((_vm.priceMultiplier), function(priceItem) {
    return _c('div', {
      staticClass: "col-6 form-group form-material"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": ("price-item-" + (priceItem.channel_id))
      }
    }, [_vm._v("\n                                              " + _vm._s(_vm.getChannelName(priceItem.channel_id)) + "\n                                            ")]), _vm._v(" "), _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (priceItem.percent_amount),
        expression: "priceItem.percent_amount"
      }],
      staticClass: "form-control",
      attrs: {
        "id": ("price-item-" + (priceItem.channel_id))
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(priceItem, "percent_amount", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.percentAmounts), function(percentAmount) {
      return _c('option', {
        domProps: {
          "value": percentAmount
        }
      }, [_vm._v("\n                                                " + _vm._s(percentAmount) + "\n                                              ")])
    }))])
  }))])])])])])])])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.icals), function(ical) {
    return _c('div', {
      staticClass: "col-lg-4"
    }, [_c('div', {
      staticClass: "panel"
    }, [_c('div', {
      staticClass: "panel-body"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12 rentals-form-inner"
    }, [_c('div', {
      staticClass: "panel-content-inner"
    }, [_c('div', {
      staticClass: "btn-group actions-dropdown"
    }, [_c('div', {
      staticClass: "dropdown"
    }, [_c('button', {
      staticClass: "btn dropdown-toggle",
      attrs: {
        "type": "button",
        "data-toggle": "dropdown"
      }
    }, [_c('i', {
      staticClass: "bulle"
    })]), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu dropdown-menu-right"
    }, [_c('button', {
      staticClass: "dropdown-item",
      attrs: {
        "data-toggle": "modal"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          return (function (e) { return _vm.updateEditableModal(e, ical.name, ical.link, ical.id, ical.ical_restriction_id, ical.override); })($event)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-edit",
      attrs: {
        "type": "button"
      }
    }), _vm._v("\n                                            " + _vm._s(_vm.$t('button.edit')) + "\n                                          ")]), _vm._v(" "), _c('button', {
      staticClass: "dropdown-item",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.deleteIcal(ical.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-remove"
    }), _vm._v(" " + _vm._s(_vm.$t('button.delete')) + "\n                                          ")])])])]), _vm._v(" "), _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-12"
    }, [_c('div', {
      staticClass: "form-group form-material"
    }, [_c('div', {
      staticClass: "form-group form-material col-12 p-l-0"
    }, [_c('label', {
      staticClass: "control-label",
      attrs: {
        "for": "ical-name"
      }
    }, [_vm._v("\n                                              " + _vm._s(ical.name) + "\n                                            ")]), _vm._v(" "), _c('input', {
      staticClass: "form-control",
      attrs: {
        "type": "text",
        "id": "ical-name"
      },
      domProps: {
        "value": ical.link
      }
    })])])])])])])])])])])
  }), _vm._v(" "), (_vm.icals.length < 3 || _vm.hasAccessToPlanIdFour(_vm.rental.userPlanId ? _vm.rental.userPlanId : null)) ? _c('div', {
    staticClass: "col-lg-4"
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 rentals-form-inner"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('div', {
    staticClass: "list-rental-empty list-rental-empty-step m-t-5"
  }, [_c('div', [_c('img', {
    attrs: {
      "src": "/static/assets/images/SuperHote_icons/rent.png"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "no-result"
  }, [_vm._v(_vm._s(_vm.$t('rentals.detail.platforms.configure_other_platform')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return (function (e) { return _vm.updateEditableModal(e, '', ''); })($event)
      }
    }
  }, [_vm._v("\n                                          " + _vm._s(_vm.$t('button.setup')) + "\n                                        ")])])])])])])])])]) : _vm._e()], 2)])])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'parameters'),
      expression: "activeTab === 'parameters'"
    }]
  }, [_c('div', {
    staticClass: "row"
  }, [_c('v-platforms', {
    attrs: {
      "platforms": _vm.platforms,
      "selectedPlatforms": _vm.selectedPlatforms
    },
    on: {
      "updateSelectedPlatforms": _vm.updateSelectedPlatforms
    }
  }), _vm._v(" "), _c('v-deposit-auto-confirmed-platforms', {
    attrs: {
      "platforms": _vm.platforms,
      "depositAutoConfirmPlatforms": _vm.selectedDepositPlatforms
    },
    on: {
      "updateSelectedDepositPlatforms": _vm.updateSelectedDepositPlatforms
    }
  }), _vm._v(" "), (_vm.hasAccessToPlanIdFour(_vm.rental.userPlanId ? _vm.rental.userPlanId : null)) ? _c('v-special-features', {
    key: _vm.rental.id,
    attrs: {
      "rentalGapFill": _vm.rental.gap_fill,
      "defaultInventory": _vm.rental.default_inventory,
      "rentalMinDaysUntilCheckin": _vm.rental.min_days_until_checkin,
      "priceReductionForPeriod": _vm.rental.price_reductions,
      "rentalId": _vm.rental.id,
      "rentalName": _vm.rental.name,
      "dependencies": _vm.rental.dependencies,
      "dynamicPrice": _vm.rental.dynamic_price_enabled,
      "percentAmounts": _vm.percentAmounts,
      "dynamicPriceSettings": _vm.rental.dynamic_price_settings,
      "rentalGapFillPercent": _vm.rental.gap_fill_percent
    },
    on: {
      "updateRentalGapFillField": _vm.updateRentalGapFillField,
      "updateRentalGapFillPercent": _vm.updateRentalGapFillPercent,
      "updateRentalDefaultInventoryField": _vm.updateRentalDefaultInventoryField,
      "updateRentalMinDaysUntilCheckin": _vm.updateRentalMinDaysUntilCheckin,
      "updateRentalPriceReduction": _vm.updateRentalPriceReduction,
      "handleDependentRentalIds": _vm.handleDependentRentalIds,
      "updateDynamicPrice": _vm.updateDynamicPrice
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'event-logger'),
      expression: "activeTab === 'event-logger'"
    }]
  }, [_c('div', {
    staticClass: "panel"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "panel-content-inner"
  }, [_c('h3', {
    staticClass: "inner-title"
  }, [_vm._v(_vm._s(_vm.$t("logs.title")))]), _vm._v(" "), _c('div', {
    staticClass: "pb-2"
  }, _vm._l((Object.keys(_vm.logs)), function(logDate) {
    return _c('div', [_c('h3', {
      staticClass: "text-left mb-2 font-weight-bold",
      staticStyle: {
        "font-size": "14px",
        "color": "#57668b"
      }
    }, [_vm._v("\n                          " + _vm._s(logDate) + "\n                        ")]), _vm._v(" "), _vm._l((_vm.logs[logDate]), function(log) {
      return _c('div', {
        staticClass: "d-block"
      }, [_c('b', {
        attrs: {
          "title": log.event_at
        }
      }, [_vm._v(_vm._s(log.hour_at) + " - ")]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(log.value)
        }
      })])
    }), _vm._v(" "), (!_vm.logs[logDate].length) ? _c('div', {
      staticClass: "d-block"
    }, [_c('span', {
      staticClass: "font-italic",
      staticStyle: {
        "color": "#b7b7b7"
      }
    }, [_vm._v(_vm._s(_vm.$t("logs.nologs")))])]) : _vm._e(), _vm._v(" "), _c('hr', {
      staticStyle: {
        "width": "15px",
        "margin-left": "0",
        "color": "#c7cce5"
      }
    })], 2)
  }))])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'vrbo-configuration-tab'),
      expression: "activeTab === 'vrbo-configuration-tab'"
    }],
    staticClass: "web-site"
  }, [_c('v-vrbo-configuration-tab', {
    ref: "vrboConfigurationTab",
    attrs: {
      "rental": _vm.rental,
      "vrboAmenitiesFeatures": _vm.vrboAmenities
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.activeTab === 'web-site'),
      expression: "activeTab === 'web-site'"
    }],
    staticClass: "web-site"
  }, [_c('v-website', {
    ref: "website",
    attrs: {
      "webSiteDefaultContent": _vm.webSiteDefaultContent,
      "rental": _vm.rental
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "addStripeAccount",
      "aria-hidden": "false",
      "aria-labelledby": "exampleGrid",
      "tabindex": "-1",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.connectStripe(_vm.rental.id)
      }
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('button.connect_stripe_account')) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#addStripeAccount')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "form-group form-material"
  }, [_c('label', [_vm._v(_vm._s(_vm.$t('input.stripe_name')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.stripe_name),
      expression: "stripe_name"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "stripe-name",
      "type": "text",
      "name": "stripe-name",
      "placeholder": _vm.$t('input.stripe_name'),
      "required": ""
    },
    domProps: {
      "value": (_vm.stripe_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.stripe_name = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeAddStripeAccount()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.cancel")) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t("button.next")) + "\n                      ")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "rental-email-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('rentals.detail.platforms.booking')) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#rental-email-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group form-material col-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rental-email"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('input.email')) + "\n                          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.booking_email),
      expression: "rental.booking_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "disabled": "disabled",
      "id": "rental-email"
    },
    domProps: {
      "value": (_vm.rental.booking_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "booking_email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group form-material col-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "rental-email"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('input.gest_notify_text')) + "\n                          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.forward_email),
      expression: "rental.forward_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "rental-forward-email"
    },
    domProps: {
      "value": (_vm.rental.forward_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "forward_email", $event.target.value)
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row d-flex align-items-center"
  }, [_c('div', {
    staticClass: "form-group form-material col-9"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "booking-hotel-id"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('input.hotel_id')) + "\n                          ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.booking_hotel_id),
      expression: "rental.booking_hotel_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "booking-hotel-id"
    },
    domProps: {
      "value": (_vm.rental.booking_hotel_id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.rental, "booking_hotel_id", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-1"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.getPropertyCode()
      }
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.$t('button.get_codes')) + "\n                          ")])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group form-material col-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "booking-room-id"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.hasAccessToPlanIdFour(_vm.rental.userPlanId ?
      _vm.rental.userPlanId : null) ? _vm.$t('input.room') :
    _vm.$t('input.room_id')) + "\n                          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.booking_room_id),
      expression: "rental.booking_room_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "booking-room-id",
      "disabled": _vm.smallLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "booking_room_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.roomCodes), function(room) {
    return _c('option', {
      domProps: {
        "value": room.code
      }
    }, [_vm._v("\n                              " + _vm._s(((room.code) + "\n                              " + (_vm.hasAccessToPlanIdFour(_vm.rental.userPlanId ?
                              _vm.rental.userPlanId : null) && room.name ? (" -\n                              " + (room.name)) : ''))) + "\n                            ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group form-material col-12"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "booking-rate-id"
    }
  }, [_vm._v("\n                            " + _vm._s(_vm.hasAccessToPlanIdFour(_vm.rental.userPlanId ?
      _vm.rental.userPlanId : null) ? _vm.$t('input.rate') :
    _vm.$t('input.rate_id')) + "\n                          ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.rental.booking_rate_id),
      expression: "rental.booking_rate_id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "booking-rate-id",
      "disabled": _vm.smallLoading
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.rental, "booking_rate_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.rateCodes), function(rate) {
    return (_vm.hasAccessToPlanIdFour(_vm.rental.userPlanId ? _vm.rental.userPlanId : null) ? _vm.roomCodes && _vm.roomCodes.length > 0 : true) ? _c('option', {
      domProps: {
        "value": rate.code
      }
    }, [_vm._v("\n                              " + _vm._s(((rate.code) + "\n                              " + (_vm.hasAccessToPlanIdFour(_vm.rental.userPlanId ?
                              _vm.rental.userPlanId : null) && rate.name ? (" -\n                              " + (rate.name)) : ''))) + "\n                            ")]) : _vm._e()
  }))])]), _vm._v(" "), (_vm.hasAccessToPlanIdFour(_vm.rental.userPlanId ? _vm.rental.userPlanId : null)) ? _c('p', {
    staticClass: "mt-10"
  }, [_c('a', {
    attrs: {
      "href": "https://superhote.com/onboarding-booking",
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.$t('rentals.detail.platforms.booking_com_info')))])]) : _vm._e()]), _vm._v(" "), _c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#rental-email-modal')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('button.cancel')) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.updateForward()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('button.save')) + "\n                      ")]), _vm._v(" "), (_vm.rental.booking_hotel_id && _vm.rental.booking_room_id) ? _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "disabled": _vm.smallLoading
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.deconnectBooking()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('button.deconnect')) + "\n                      ")]) : _vm._e()])], 1)])])]), _vm._v(" "), _c('v-vrbo-configuration-modal', {
    attrs: {
      "fetchRental": _vm.fetchRental,
      "rental": _vm.rental
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "modal fade custom-modal",
    attrs: {
      "id": "rental-configure-other-platform-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "autocomplete": "off"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('rentals.detail.platforms.configure_other_platform')) + "\n                            ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.closeModal('#rental-configure-other-platform-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "radio-cont m-t-15 m-l-10"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group form-material col-12 p-l-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "other-platform-name"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('input.name')) + "\n                              "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "other-platform-name"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group form-material col-12 p-l-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "other-platform-link"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('input.link')) + "\n                              "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.link),
      expression: "link"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "other-platform-link"
    },
    domProps: {
      "value": (_vm.link)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.link = $event.target.value
      }
    }
  })]), _vm._v(" "), (_vm.hasAccessToPlanIdFour(_vm.rental.userPlanId ? _vm.rental.userPlanId : null)) ? _c('div', {
    staticClass: "form-group form-material col-12 p-l-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "other-platform-link"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('calendar.index.availabilities_filter')) + "\n                              "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icalRestrictionId),
      expression: "icalRestrictionId"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ical-restrictions"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.icalRestrictionId = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.icalRestrictions), function(icalRestriction) {
    return _c('option', {
      domProps: {
        "value": icalRestriction.id
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.$t(("rentals.detail.platforms.ical." + (icalRestriction.name)))) + "\n                              ")])
  }))]) : _vm._e(), _vm._v(" "), (_vm.hasAccessToPlanIdFour(_vm.rental.userPlanId ? _vm.rental.userPlanId : null)) ? _c('div', {
    staticClass: "form-group form-material col-12 p-l-0"
  }, [_c('label', {
    staticClass: "control-label",
    attrs: {
      "for": "ical-override"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.$t('rentals.detail.popovers.ical_override')) + "\n                              "), _c('span', {
    staticClass: "required"
  }, [_vm._v("*")])]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.icalOverride),
      expression: "icalOverride"
    }],
    staticClass: "form-control",
    attrs: {
      "id": "ical-override"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.icalOverride = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('button.yes')) + "\n                              ")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("\n                                " + _vm._s(_vm.$t('button.no')) + "\n                              ")])])]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  }), _vm._v(" "), (!_vm.smallLoading) ? _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        _vm.closeModal('#rental-configure-other-platform-modal')
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('button.cancel')) + "\n                      ")]) : _vm._e(), _vm._v(" "), (!_vm.smallLoading) ? _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.addOtherPlatforms()
      }
    }
  }, [_vm._v("\n                        " + _vm._s(_vm.$t('button.save')) + "\n                      ")]) : _vm._e()], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "duplicate-checklist-modal",
      "aria-hidden": "true",
      "aria-labelledby": "exampleGrid",
      "role": "dialog",
      "tabindex": "-1"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-simple modal-center"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row header"
  }, [_c('div', {
    staticClass: "col-8"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("\n                            " + _vm._s(_vm.$t("rentals.detail.checklists.duplicate_checklist_modal_title")) + "\n                          ")])]), _vm._v(" "), _c('div', {
    staticClass: "col-4"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#duplicate-checklist-modal')
      }
    }
  }, [_c('span', {
    staticClass: "close-btn",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('h5', [_vm._v("\n                        " + _vm._s(_vm.$t("rentals.detail.checklists.duplicate_checklist_modal_body")) + "\n                      ")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newChecklistGroup.rental_id),
      expression: "newChecklistGroup.rental_id"
    }],
    staticClass: "form-control type-select",
    attrs: {
      "name": "rentals",
      "id": "duplicate-checklist-rentals"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.newChecklistGroup, "rental_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, _vm._l((_vm.rentals), function(rental) {
    return _c('option', {
      domProps: {
        "value": rental.id
      }
    }, [_vm._v("\n                          " + _vm._s(rental.name) + "\n                        ")])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('div', {
    staticClass: "m-b-40"
  }, [_c('v-loading', {
    attrs: {
      "isLoading": _vm.smallLoading,
      "height": 50,
      "width": 50,
      "viewbox": '0 0 50 50',
      "cx": 25,
      "cy": 25,
      "r": 22,
      "isHeightAuto": true
    }
  })], 1), _vm._v(" "), _c('button', {
    staticClass: "btn waves-effect waves-classic btn-cancel",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.closeModal('#duplicate-checklist-modal')
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('button.cancel')) + "\n                    ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary waves-effect waves-classic btn-save",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.duplicateFormOrChecklist(_vm.newChecklistGroup)
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.$t('button.duplicate')) + "\n                    ")])])])])])], 1)], 2), _vm._v(" "), _c('v-billingModal', {
    attrs: {
      "planId": 'superhote-sms',
      "rentalId": _vm.rental.id
    }
  }), _vm._v(" "), _c('v-sync-in-progress-modal'), _vm._v(" "), _c('v-import-bookings-from-file', {
    attrs: {
      "rentalId": _vm.rental.id,
      "fromRental": "true"
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a6deddf"}!./src/app/pages/rentals/detail/detail.html
// module id = 1316
// module chunks = 0